type OnChangeHandler = (isDark: boolean) => void;

export enum THEME {
  DARK = 'dark',
  LIGHT = 'light'
};

export const STORAGE_KEY = 'theme';

const notifyHandlers = (handlers: OnChangeHandler[], isDark: boolean) => {
  handlers.forEach(handler => handler(isDark));
};

export default (storage: Storage, storageKey = STORAGE_KEY) => {
  const handlers: OnChangeHandler[] = [];
  const schemeChangeHandler = (event: MediaQueryList | MediaQueryListEvent) => {
    const isDark = event.matches;
    notifyHandlers(handlers, isDark);
  };

  let prefersDarkScheme: MediaQueryList | undefined;

  return {
    initialize() {
      if (prefersDarkScheme) {
        console.warn('Theme switcher already initialized');
        return this;
      }

      const theme = storage.getItem(storageKey);

      if (theme) {
        const isDark = theme === THEME.DARK;
        notifyHandlers(handlers, isDark);
      }

      prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');
      prefersDarkScheme.addEventListener('change', schemeChangeHandler);
      
      if (!theme) schemeChangeHandler(prefersDarkScheme);
      return this;
    },
    onChange(handler: OnChangeHandler) {
      handlers.push(handler);
      return this;
    },
    switchToDark(isDark: boolean) {
      storage.setItem(storageKey, isDark ? THEME.DARK : THEME.LIGHT);
      notifyHandlers(handlers, isDark);
      return this;
    },
    destroy() {
      prefersDarkScheme?.removeEventListener('change', schemeChangeHandler);
      prefersDarkScheme = undefined;
    }
  };
};

/*
type OnChangeHandler = (isDark: boolean) => void;

export enum THEME {
  DARK = 'dark',
  LIGHT = 'light',
}

export const STORAGE_KEY = 'theme';

export default (storage: Storage, storageKey = STORAGE_KEY) => {
  const createSchemeChangeHandler = (handlers: OnChangeHandler[]) => 
    (event: MediaQueryList | MediaQueryListEvent) => {
      const isDark = event.matches;
      handlers.forEach(handler => handler(isDark));
    };

  const initializeHandlers = (
    storage: Storage,
    storageKey: string,
    handlers: OnChangeHandler[],
    prefersDarkScheme: MediaQueryList | undefined,
    schemeChangeHandler: (event: MediaQueryList | MediaQueryListEvent) => void
  ) => {
    const theme = storage.getItem(storageKey);
    const isDark = theme === THEME.DARK;
    handlers.forEach(handler => handler(isDark));

    prefersDarkScheme?.addEventListener('change', schemeChangeHandler);
    schemeChangeHandler(prefersDarkScheme);
  };

  const addHandler = (handlers: OnChangeHandler[], handler: OnChangeHandler) => {
    return [...handlers, handler];
  };

  const notifyHandlers = (handlers: OnChangeHandler[], isDark: boolean) => {
    handlers.forEach(handler => handler(isDark));
  };

  const setTheme = (
    storage: Storage,
    storageKey: string,
    handlers: OnChangeHandler[],
    isDark: boolean
  ) => {
    storage.setItem(storageKey, isDark ? THEME.DARK : THEME.LIGHT);
    notifyHandlers(handlers, isDark);
  };

  const destroyListeners = (
    prefersDarkScheme: MediaQueryList | undefined,
    schemeChangeHandler: (event: MediaQueryList | MediaQueryListEvent) => void
  ) => {
    prefersDarkScheme?.removeEventListener('change', schemeChangeHandler);
  };

  // Initialize state and event handlers
  const handlers: OnChangeHandler[] = [];
  const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');
  const schemeChangeHandler = createSchemeChangeHandler(handlers);

  return {
    initialize() {
      initializeHandlers(storage, storageKey, handlers, prefersDarkScheme, schemeChangeHandler);
      return this;
    },
    onChange(handler: OnChangeHandler) {
      handlers.push(handler);
      return this;
    },
    switchToDark(isDark: boolean) {
      setTheme(storage, storageKey, handlers, isDark);
      return this;
    },
    destroy() {
      destroyListeners(prefersDarkScheme, schemeChangeHandler);
    },
  };
};
*/